import * as React from 'react';

type CheckmarkBoldIconProps = React.SVGProps<SVGSVGElement> & {
  strokeWidth?: number;
};

export const CheckmarkVeryBoldIcon = ({ ...props }: CheckmarkBoldIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m9.24 22.56-7.65-7.65 2.82-2.82 4.35 4.35L19.394 1.83l3.21 2.34L9.24 22.56Z"
    />
  </svg>
);
